/**
 * Field extraction utilities for blueprints/templates
 */

/**
 * Extract field names from a blueprint's data structure
 * Handles both object-based (with sections) and array-based (legacy) formats
 */
export const extractBlueprintFields = (blueprintData: any): string[] => {
  const fields: string[] = [];
  
  if (!blueprintData) {
    return fields;
  }
  
  // Handle object-based structure with sections
  if (blueprintData.sections && typeof blueprintData.sections === 'object') {
    Object.values(blueprintData.sections).forEach((section: any) => {
      if (typeof section === 'object') {
        // Iterate through section properties, skip internal properties (starting with _)
        Object.entries(section).forEach(([key, value]: [string, any]) => {
          if (!key.startsWith('_') && typeof value === 'object' && value.label) {
            const fieldName = value.label || value.name || value.id;
            if (fieldName && !fields.includes(fieldName)) {
              fields.push(fieldName);
            }
          }
        });
      }
    });
  }
  // Handle array-based structure (legacy format)
  else if (Array.isArray(blueprintData)) {
    blueprintData.forEach((section: any) => {
      if (section.fields && Array.isArray(section.fields)) {
        section.fields.forEach((field: any) => {
          const fieldName = field.label || field.name || field.id;
          if (fieldName && !fields.includes(fieldName)) {
            fields.push(fieldName);
          }
        });
      }
    });
  }
  
  return fields;
};
